export default __webpack_public_path__ + "static/media/ic_belgium.d85c5879.svg";